import React from 'react';

export const ROTATION_TABLE = {
  0: { 1: 'S',   2: 'OH1', 3: 'MB1', 4: 'OPP', 5: 'OH2', 6: 'MB2' },
  1: { 1: 'OH1', 2: 'MB1', 3: 'OPP', 4: 'OH2', 5: 'MB2', 6: 'S'   },
  2: { 1: 'MB1', 2: 'OPP', 3: 'OH2', 4: 'MB2', 5: 'S',   6: 'OH1' },
  3: { 1: 'OPP', 2: 'OH2', 3: 'MB2', 4: 'S',   5: 'OH1', 6: 'MB1' },
  4: { 1: 'OH2', 2: 'MB2', 3: 'S',   4: 'OH1', 5: 'MB1', 6: 'OPP' },
  5: { 1: 'MB2', 2: 'S',   3: 'OH1', 4: 'MB1', 5: 'OPP', 6: 'OH2' },
};

export const ROLE_FAMILY = {
  S: 'S', OPP: 'OPP',
  OH1: 'OH', OH2: 'OH',
  MB1: 'MB', MB2: 'MB',
  L: 'L',
};

export const ROLE_META = {
  S:   { name: 'Setter',         abbr: 'S',   capacity: 1, desc: 'Runs the offence.' },
  OH:  { name: 'Outside Hitter', abbr: 'OH',  capacity: 2, desc: 'Power pin attacker. Passes, hits, blocks.' },
  MB:  { name: 'Middle Blocker', abbr: 'MB',  capacity: 2, desc: 'Front-row blocker, quick attacks.' },
  OPP: { name: 'Opposite',       abbr: 'OPP', capacity: 1, desc: 'Right-side hitter, back-row attack.' },
  L:   { name: 'Libero',         abbr: 'L',   capacity: 1, desc: 'Back-row defender. Subs for MB.' },
};

export const ROLE_ORDER = ['S', 'OH', 'MB', 'OPP', 'L'];

export const POS_COORDS = {
  4: { x: 180, y: 170, label: 'P4' },
  3: { x: 380, y: 170, label: 'P3' },
  2: { x: 580, y: 170, label: 'P2' },
  5: { x: 180, y: 350, label: 'P5' },
  6: { x: 380, y: 350, label: 'P6' },
  1: { x: 580, y: 350, label: 'P1' },
};

const COURT_GEOM = {
  vbW: 760, vbH: 520,
  netY: 80,
  courtX: 80, courtY: 80, courtW: 600, courtH: 360,
};

function CourtBackground() {
  const g = COURT_GEOM;
  return (
    <g>
      <rect x={g.courtX} y={g.courtY} width={g.courtW} height={g.courtH}
        fill="rgba(157,21,21,0.07)" stroke="none" />
      <rect x={g.courtX} y={g.courtY} width={g.courtW} height={g.courtH}
        fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" />
      <line x1={g.courtX} y1={g.courtY + g.courtH / 3}
        x2={g.courtX + g.courtW} y2={g.courtY + g.courtH / 3}
        stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
      <g>
        <rect x={g.courtX - 6} y={g.netY - 18} width={g.courtW + 12} height={4}
          fill="#222" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5" />
        {[...Array(60)].map((_, i) => (
          <line key={i}
            x1={g.courtX + (g.courtW / 60) * i}
            y1={g.netY - 14}
            x2={g.courtX + (g.courtW / 60) * i}
            y2={g.netY}
            stroke="rgba(255,255,255,0.18)" strokeWidth="0.5" />
        ))}
        <line x1={g.courtX} y1={g.netY}
          x2={g.courtX + g.courtW} y2={g.netY}
          stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" />
        <line x1={g.courtX} y1={g.netY - 22} x2={g.courtX} y2={g.netY + 14}
          stroke="var(--di-accent)" strokeWidth="1.5" />
        <line x1={g.courtX + g.courtW} y1={g.netY - 22} x2={g.courtX + g.courtW} y2={g.netY + 14}
          stroke="var(--di-accent)" strokeWidth="1.5" />
      </g>
      <text x={g.courtX + g.courtW / 2} y={g.netY - 26}
        fill="rgba(255,255,255,0.3)"
        fontFamily="JetBrains Mono, monospace"
        fontSize="9"
        letterSpacing="0.2em"
        textAnchor="middle">NET</text>
      <rect x={g.courtX} y={g.netY - 70} width={g.courtW} height={50}
        fill="rgba(255,255,255,0.012)" stroke="rgba(255,255,255,0.07)" strokeDasharray="3 4" />
      <text x={g.courtX + g.courtW / 2} y={g.netY - 42}
        fill="rgba(255,255,255,0.18)"
        fontFamily="JetBrains Mono, monospace"
        fontSize="9"
        letterSpacing="0.2em"
        textAnchor="middle">OPPONENT</text>
    </g>
  );
}

function PlayerToken({ x, y, label, isYou, dropKey, sub, avatarUrl }) {
  const [imgError, setImgError] = React.useState(false);
  const animClass = isYou && dropKey ? 'dropped' : '';
  const clipId = `av-${x}-${y}`;
  const safeAvatarUrl = avatarUrl && /^https?:\/\//i.test(avatarUrl) ? avatarUrl : null;
  const showAvatar = safeAvatarUrl && !imgError;

  // Reset error state when avatarUrl changes
  React.useEffect(() => { setImgError(false); }, [avatarUrl]);

  return (
    <g transform={`translate(${x} ${y})`}>
      <g key={dropKey || 'static'}
         className={`player-token ${isYou ? 'you' : ''} ${animClass}`}>
        <circle className="bg" r={22} />
        {showAvatar ? (
          <>
            <clipPath id={clipId}><circle r={22} /></clipPath>
            <image
              href={safeAvatarUrl}
              x={-22} y={-22} width={44} height={44}
              clipPath={`url(#${clipId})`}
              preserveAspectRatio="xMidYMid slice"
              onError={() => setImgError(true)}
            />
          </>
        ) : (
          <g>
            <circle cx={0} cy={-6} r={7} fill="rgba(255,255,255,0.9)" />
            <path d="M-13 16 C-13 8 13 8 13 16" fill="rgba(255,255,255,0.9)" />
            {!isYou && sub && (
              <text y={18} fontSize="7" textAnchor="middle"
                    fill="rgba(255,255,255,0.55)"
                    letterSpacing="0.1em">{sub}</text>
            )}
          </g>
        )}
      </g>
    </g>
  );
}

function PositionSlot({ pos, role, status, onHover, onClick }) {
  const isHighlighted = status === 'highlighted';
  const fillCls = `slot-fill ${isHighlighted ? 'highlighted' : ''} ${status === 'full' ? 'full' : ''}`;
  const strokeCls = `slot-stroke ${isHighlighted ? 'highlighted' : ''}`;
  return (
    <g className="slot-hit"
       onMouseEnter={() => onHover && onHover(role)}
       onMouseLeave={() => onHover && onHover(null)}
       onClick={() => onClick && onClick(role)}>
      <rect className={fillCls}
        x={pos.x - 78} y={pos.y - 58}
        width={156} height={116} rx={2} />
      <rect className={strokeCls}
        x={pos.x - 78} y={pos.y - 58}
        width={156} height={116} rx={2} />
      <text x={pos.x} y={pos.y - 38}
        className="court-num">{pos.label}</text>
    </g>
  );
}

export function Court({ level, rotation, claims, hoveredRole, onHoverRole, onClaim, lastClaimedTick, userAvatar, avatarMap = {} }) {
  const g = COURT_GEOM;

  if (level === 'beg') {
    return (
      <svg className="di-court-svg" viewBox={`0 0 ${g.vbW} ${g.vbH}`}>
        <CourtBackground />
        {[1, 2, 3, 4, 5, 6].map((n) => {
          const p = POS_COORDS[n];
          const claim = claims.find(c => c.slot === `BEG${n}`);
          const isYou = claim && claim.isYou;
          const taken = !!claim;
          const hovered = hoveredRole === `BEG${n}`;
          return (
            <g key={n}>
              <PositionSlot
                pos={p}
                role={`BEG${n}`}
                status={hovered ? 'highlighted' : (taken ? 'full' : 'open')}
                onHover={taken && !isYou ? null : onHoverRole}
                onClick={taken && !isYou ? null : onClaim}
              />
              {taken
                ? <PlayerToken x={p.x} y={p.y} label={isYou ? 'YOU' : '?'}
                    isYou={isYou}
                    dropKey={isYou ? `t-${lastClaimedTick}` : null}
                    sub={null}
                    avatarUrl={isYou ? userAvatar : (claim?.userId ? avatarMap[claim.userId] || null : null)} />
                : <text x={p.x} y={p.y}
                    fill="rgba(255,255,255,0.4)"
                    fontFamily="Bebas Neue"
                    fontSize="16"
                    letterSpacing="0.15em"
                    textAnchor="middle"
                    dominantBaseline="central">OPEN</text>}
            </g>
          );
        })}
      </svg>
    );
  }

  const layout = ROTATION_TABLE[rotation] || ROTATION_TABLE[0];
  const familyClaimQueues = {};
  Object.keys(claims).forEach(family => {
    familyClaimQueues[family] = [...claims[family]];
  });

  const positionAssignments = {};
  const courtPositionOrder = [4, 3, 2, 5, 6, 1];
  for (const cp of courtPositionOrder) {
    const roleSlot = layout[cp];
    const family = ROLE_FAMILY[roleSlot];
    if (!family) continue;
    const queue = familyClaimQueues[family];
    if (queue && queue.length > 0) {
      positionAssignments[cp] = queue.shift();
    }
  }

  return (
    <svg className="di-court-svg" viewBox={`0 0 ${g.vbW} ${g.vbH}`}>
      <CourtBackground />

      {courtPositionOrder.map((cp) => {
        const p = POS_COORDS[cp];
        const roleSlot = layout[cp];
        const family = ROLE_FAMILY[roleSlot];
        const claim = positionAssignments[cp];
        const isYou = claim && claim.isYou;
        const isHovered = hoveredRole === family;
        const meta = ROLE_META[family];
        const taken = !!claim;
        const familyClaims = claims[family] || [];
        const familyFull = familyClaims.length >= meta.capacity;

        let status = 'open';
        if (isHovered) status = 'highlighted';
        else if (familyFull) status = 'full';

        return (
          <g key={cp}>
            <PositionSlot
              pos={p}
              role={family}
              status={status}
              onHover={onHoverRole}
              onClick={familyFull && !isYou ? null : onClaim}
            />
            {taken ? (
              <PlayerToken
                x={p.x} y={p.y}
                label={isYou ? 'YOU' : meta.abbr}
                sub={isYou ? meta.abbr : null}
                isYou={isYou}
                dropKey={isYou ? `t-${lastClaimedTick}` : null}
                avatarUrl={isYou ? userAvatar : (claim?.userId ? avatarMap[claim.userId] || null : null)}
              />
            ) : (
              <g>
                <text x={p.x} y={p.y - 7}
                  fill={isHovered ? 'var(--di-accent)' : 'rgba(255,255,255,0.78)'}
                  fontFamily="Bebas Neue"
                  fontSize="22"
                  letterSpacing="0.06em"
                  textAnchor="middle"
                  dominantBaseline="central">{meta.abbr}</text>
                <text x={p.x} y={p.y + 14}
                  fill="rgba(255,255,255,0.32)"
                  fontFamily="JetBrains Mono, monospace"
                  fontSize="9"
                  letterSpacing="0.18em"
                  textAnchor="middle">OPEN</text>
              </g>
            )}
          </g>
        );
      })}

      {(() => {
        const liberoClaim = (claims.L || [])[0];
        const isYou = liberoClaim && liberoClaim.isYou;
        const isHovered = hoveredRole === 'L';
        const status = isHovered ? 'highlighted' : (liberoClaim ? 'full' : 'open');
        return (
          <g>
            <rect x={g.courtX + g.courtW + 10} y={g.courtY + 40}
              width={50} height={130}
              fill="rgba(255,255,255,0.02)"
              stroke="rgba(255,255,255,0.18)"
              strokeDasharray="2 3" />
            <text x={g.courtX + g.courtW + 35} y={g.courtY + 30}
              fill="rgba(255,255,255,0.25)"
              fontFamily="JetBrains Mono, monospace"
              fontSize="8"
              letterSpacing="0.2em"
              textAnchor="middle">BENCH</text>

            <g className="slot-hit"
               onMouseEnter={() => onHoverRole && onHoverRole('L')}
               onMouseLeave={() => onHoverRole && onHoverRole(null)}
               onClick={() => liberoClaim && !isYou ? null : onClaim('L')}>
              <rect className={`slot-fill ${status === 'highlighted' ? 'highlighted' : ''}`}
                x={g.courtX + g.courtW + 14} y={g.courtY + 70}
                width={42} height={62} />
              <rect className={`slot-stroke ${status === 'highlighted' ? 'highlighted' : ''}`}
                x={g.courtX + g.courtW + 14} y={g.courtY + 70}
                width={42} height={62} />
              {liberoClaim
                ? <PlayerToken
                    x={g.courtX + g.courtW + 35}
                    y={g.courtY + 100}
                    label={isYou ? 'YOU' : 'L'}
                    sub={isYou ? 'L' : null}
                    isYou={isYou}
                    dropKey={isYou ? `t-${lastClaimedTick}` : null}
                    avatarUrl={isYou ? userAvatar : (liberoClaim?.userId ? avatarMap[liberoClaim.userId] || null : null)} />
                : <g>
                    <text x={g.courtX + g.courtW + 35} y={g.courtY + 95}
                      fill={isHovered ? 'var(--di-accent)' : 'rgba(255,255,255,0.78)'}
                      fontFamily="Bebas Neue"
                      fontSize="20"
                      textAnchor="middle"
                      dominantBaseline="central">L</text>
                    <text x={g.courtX + g.courtW + 35} y={g.courtY + 113}
                      fill="rgba(255,255,255,0.32)"
                      fontFamily="JetBrains Mono, monospace"
                      fontSize="7"
                      letterSpacing="0.15em"
                      textAnchor="middle">OPEN</text>
                  </g>}
            </g>
          </g>
        );
      })()}

      <g opacity="0.45">
        <path d={`M ${g.courtX + g.courtW + 90} ${g.courtY + g.courtH - 70}
                  a 28 28 0 1 0 18 -22`}
              stroke="rgba(255,255,255,0.5)"
              strokeWidth="1.2"
              fill="none" />
        <polygon points={`${g.courtX + g.courtW + 113},${g.courtY + g.courtH - 90}
                          ${g.courtX + g.courtW + 119},${g.courtY + g.courtH - 96}
                          ${g.courtX + g.courtW + 105},${g.courtY + g.courtH - 96}`}
                 fill="rgba(255,255,255,0.5)" />
        <text x={g.courtX + g.courtW + 75}
              y={g.courtY + g.courtH - 28}
              fill="rgba(255,255,255,0.45)"
              fontFamily="JetBrains Mono, monospace"
              fontSize="8"
              letterSpacing="0.18em">ROTATE</text>
      </g>
    </svg>
  );
}
